import React, { useState, useEffect, forwardRef } from "react";
import { useForm } from "react-hook-form";
import TextField from "@mui/material/TextField";
import useFetch from "../../../../../hooks/useFetch";
import moment from "jalali-moment";
import ModalShell from "../../../../shares/dashboard/ModalShell";

const FORM_ID = "add-student-form";

const AddGroups = forwardRef(({ close, get, edit }, ref) => {
  const [call, setCall] = useState({
    username: "",
    first_name: "",
    last_name: "",
    groups: [],
    password: "",
    studentuser: {
      father_name: "",
      phone_number: "",
      father_number: "",
      mother_number: "",
      home_number: "",
      address: "",
      registration_date: moment().format("YYYY-MM-DD"),
      student_school: "",
      student_type: "",
      student_gender: "",
      student_grade: "",
    },
  });

  const newGroup = useFetch({
    method: "POST",
    url: `management/users/`,
    noHeader: false,
    trigger: false,
    data: call,
    caller: get,
  });

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    values: call,
  });

  const onSubmit = (e) => {
    // e.preventDefault();

    newGroup.reFetch();
  };
  useEffect(() => {
    newGroup.status === 201 && close();
  }, [newGroup.status]);

  return (
    <ModalShell
      ref={ref}
      close={close}
      title={edit ? "ویرایش دانش‌آموز" : "دانش‌آموز جدید"}
      subtitle="مشخصات ورود دانش‌آموز"
      footer={
        <div className="flex justify-start">
          <button
            form={FORM_ID}
            type="submit"
            disabled={newGroup.loading}
            className="rounded-soft bg-primary px-2xl py-sm text-base text-white transition-colors duration-150 hover:bg-primary-hover active:bg-primary-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-60 motion-reduce:transition-none"
          >
            {newGroup.loading ? "در حال ثبت…" : "ثبت دانش‌آموز"}
          </button>
        </div>
      }
    >
      <form
        id={FORM_ID}
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col gap-lg text-sm"
      >
        <div>
          <label htmlFor="username" className="mb-2xs block text-sm text-ink-muted">
            کدملی
          </label>
          <TextField
            name="username"
            type={"number"}
            value={call.username}
            placeholder="کدملی"
            {...register("username", {
              required: "کدملی را وارد کنید",
            })}
            error={!!errors.username}
            helperText={errors.username ? errors.username.message : ""}
            onChange={(e) => {
              setCall({ ...call, username: e.target.value });
            }}
            fullWidth
          />
        </div>
        <div>
          <label htmlFor="first_name" className="mb-2xs block text-sm text-ink-muted">
            نام
          </label>
          <TextField
            name="first_name"
            value={call.first_name}
            placeholder="نام"
            {...register("first_name", {
              required: "نام را وارد کنید",
            })}
            error={!!errors.first_name}
            helperText={errors.first_name ? errors.first_name.message : ""}
            onChange={(e) => {
              setCall({ ...call, first_name: e.target.value });
            }}
            fullWidth
          />
        </div>
        <div>
          <label htmlFor="last_name" className="mb-2xs block text-sm text-ink-muted">
            نام خانوادگی
          </label>
          <TextField
            name="last_name"
            value={call.last_name}
            placeholder="نام خانوادگی"
            {...register("last_name", {
              required: "نام خانوادگی را وارد کنید",
            })}
            error={!!errors.last_name}
            helperText={errors.last_name ? errors.last_name.message : ""}
            onChange={(e) => {
              setCall({ ...call, last_name: e.target.value });
            }}
            fullWidth
          />
        </div>

        <div>
          <label htmlFor="password" className="mb-2xs block text-sm text-ink-muted">
            رمز عبور
          </label>
          <TextField
            name="password"
            value={call.password}
            placeholder="رمز عبور"
            {...register("password", {
              required: "رمز عبور را وارد کنید",
            })}
            error={!!errors.password}
            helperText={errors.password ? errors.password.message : ""}
            onChange={(e) => {
              setCall({ ...call, password: e.target.value });
            }}
            fullWidth
          />
        </div>

      </form>
    </ModalShell>
  );
});

export default AddGroups;

const digits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
